import React, { useEffect } from 'react';
import { CATEGORIES } from '../data/foodData';
import FoodCard from './FoodCard';
import { ChevronLeft } from 'lucide-react';

const MenuSection = ({ items, searchQuery, selectedCategory, setSelectedCategory }) => {
    // If user is searching, always show dish results regardless of current view
    const isSearching = searchQuery.trim() !== "";

    // Back to categories view
    const handleBack = () => setSelectedCategory(null);

    // Filter items based on category (if selected and not searching)
    const categoryItems = items.filter(dish =>
        !isSearching && selectedCategory ? dish.category === selectedCategory : true
    );

    // Scroll to top of menu when category changes
    useEffect(() => {
        if (selectedCategory) {
            const menuElement = document.getElementById('menu');
            if (menuElement) {
                menuElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [selectedCategory]);

    if (isSearching) {
        return (
            <section className="menu-section" id="menu">
                <div className="section-title" style={{ padding: '0 5%', marginBottom: '2rem' }}>
                    <h2>Search <span style={{ color: 'var(--primary)' }}>Results</span></h2>
                </div>
                <div className="menu-grid">
                    {items.map(food => <FoodCard key={food.id} food={food} />)}
                    {items.length === 0 && <p className="no-results" style={{ gridColumn: '1/-1', textAlign: 'center', color: 'var(--text-muted)' }}>No dishes matches your search.</p>}
                </div>
            </section>
        );
    }

    return (
        <section className="menu-section" id="menu" style={{ paddingBottom: '5rem' }}>
            {!selectedCategory ? (
                <>
                    <div className="section-title" style={{ padding: '0 5%', marginBottom: '3rem' }}>
                        <h2 style={{ fontSize: '3rem' }}>Full <span style={{ color: 'var(--primary)' }}>Menu</span></h2>
                        <p style={{ color: 'var(--text-muted)' }}>Choose a category to see its specialties</p>
                    </div>

                    <div className="category-grid">
                        {CATEGORIES.map((cat) => (
                            <div
                                key={cat.name}
                                className="category-card"
                                onClick={() => setSelectedCategory(cat.name)}
                            >
                                <img
                                    src={cat.image}
                                    alt={cat.name}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=800&q=80";
                                    }}
                                />
                                <div className="category-overlay">
                                    <h3 style={{ fontSize: '2rem', fontWeight: '800' }}>{cat.name}</h3>
                                    <p style={{ color: 'var(--text-muted)', marginTop: '0.5rem', opacity: 0.8 }}>{cat.description}</p>
                                    <button className="voir-choix-btn">Voir les choix</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <>
                    <div className="back-btn" onClick={handleBack} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', margin: '2rem 5%', cursor: 'pointer', color: 'var(--primary)', fontWeight: '700' }}>
                        <ChevronLeft size={20} /> Back to Categories
                    </div>
                    <div className="section-title" style={{ padding: '0 5%', marginBottom: '3rem' }}>
                        <h2>Our Selection of <span style={{ color: 'var(--primary)' }}>{selectedCategory}</span></h2>
                    </div>
                    <div className="menu-grid">
                        {categoryItems.map(food => <FoodCard key={food.id} food={food} />)}
                    </div>
                </>
            )}
        </section>
    );
};

export default MenuSection;
